import { Component, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-redirect-map',
  templateUrl: './redirect-map.component.html',
  styleUrls: ['./redirect-map.component.scss']
})
export class RedirectMapComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  _isPlatformServer: boolean = false;

  constructor(@Inject(PLATFORM_ID) public readonly platformId: string) 
  { 
    platformId;
  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    if(!this._isPlatformServer){
      // console.log('RedirectMap component initialized with component data', this.rendering);
      // var nameValueList = ((this.rendering?.fields as any)?.Redirects?.value as string).split("&");
      // nameValueList.forEach(element => {
      //     var replacedElement = element.replace(/%2F/g, '/');
      //     var [key,value] = replacedElement.split("=");

      //     if(window.location.pathname == key.trim()){
      //       window.location.href = window.location.origin+value.trim();
      //     }
      //     console.log(key,value)
      // });
    }
  } 
}
